// Globaler Error-Handler für automatische Fehler-Erfassung
// Erfasst alle JavaScript-Fehler und Promise-Rejections

let errorHandlerInitialized = false;
let pendingErrors = [];

// Device-Info sammeln
const getDeviceInfo = () => {
  try {
    return {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      pathname: window.location.pathname,
    };
  } catch (e) {
    return {
      error: 'Fehler beim Sammeln der Device-Info',
      timestamp: new Date().toISOString(),
    };
  }
};

// Speichere Fehler in IndexedDB (wird später implementiert)
const saveErrorToIndexedDB = async (errorData) => {
  try {
    // Wird in App.jsx implementiert, hier nur Platzhalter
    pendingErrors.push(errorData);
    return true;
  } catch (e) {
    console.error('[ErrorHandler] Fehler beim Speichern in IndexedDB:', e);
    return false;
  }
};

// Sende Fehler an Backend (wenn verfügbar)
const sendErrorToBackend = async (errorData, backendUrl, email) => {
  try {
    if (!backendUrl || !email) {
      return false;
    }

    const normalizedUrl = backendUrl.replace(/\/$/, '');
    const apiUrl = `${normalizedUrl}/api/feedback`;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_email: email,
        type_: 'BUG',
        title: `Automatischer Fehler: ${errorData.message || 'Unbekannter Fehler'}`,
        description: `Fehlertyp: ${errorData.type || 'Error'}\n\nFehlermeldung: ${errorData.message || 'Keine Meldung'}\n\nStack-Trace:\n${errorData.stack || 'Kein Stack-Trace verfügbar'}\n\nURL: ${errorData.url || window.location.href}\n\nDevice-Info:\n${JSON.stringify(errorData.deviceInfo, null, 2)}`,
        device_info: errorData.deviceInfo,
        frontend_version: process.env.REACT_APP_VERSION || '0.1.52',
      }),
    });

    if (response.ok) {
      return true;
    }
    return false;
  } catch (e) {
    console.error('[ErrorHandler] Fehler beim Senden an Backend:', e);
    return false;
  }
};

// Handler für JavaScript-Fehler
const handleError = (event) => {
  const errorData = {
    type: 'Error',
    message: event.message || 'Unbekannter Fehler',
    filename: event.filename || 'Unbekannt',
    lineno: event.lineno || 0,
    colno: event.colno || 0,
    stack: event.error?.stack || null,
    url: window.location.href,
    deviceInfo: getDeviceInfo(),
    timestamp: new Date().toISOString(),
  };

  console.error('[ErrorHandler] Fehler erfasst:', errorData);

  // Speichere in IndexedDB
  saveErrorToIndexedDB(errorData);

  // Versuche an Backend zu senden (wird in App.jsx mit Backend-URL und Email aufgerufen)
  // Hier nur speichern, Senden erfolgt später
};

// Handler für Promise-Rejections
const handleUnhandledRejection = (event) => {
  const errorData = {
    type: 'UnhandledRejection',
    message: event.reason?.message || String(event.reason) || 'Unbehandelte Promise-Rejection',
    stack: event.reason?.stack || null,
    reason: event.reason ? String(event.reason) : 'Unbekannt',
    url: window.location.href,
    deviceInfo: getDeviceInfo(),
    timestamp: new Date().toISOString(),
  };

  console.error('[ErrorHandler] Unbehandelte Promise-Rejection erfasst:', errorData);

  // Speichere in IndexedDB
  saveErrorToIndexedDB(errorData);

  // Verhindere Standard-Fehlerbehandlung (optional)
  // event.preventDefault();
};

// Initialisiere Error-Handler
export const initializeErrorHandler = () => {
  if (errorHandlerInitialized) {
    return;
  }

  // JavaScript-Fehler
  window.addEventListener('error', handleError, true);

  // Promise-Rejections
  window.addEventListener('unhandledrejection', handleUnhandledRejection);

  errorHandlerInitialized = true;
  console.log('[ErrorHandler] Error-Handler initialisiert');
};

// Deinitialisiere Error-Handler (für Tests)
export const deinitializeErrorHandler = () => {
  if (!errorHandlerInitialized) {
    return;
  }

  window.removeEventListener('error', handleError, true);
  window.removeEventListener('unhandledrejection', handleUnhandledRejection);

  errorHandlerInitialized = false;
  console.log('[ErrorHandler] Error-Handler deinitialisiert');
};

// Hole ausstehende Fehler (für Upload)
export const getPendingErrors = () => {
  return [...pendingErrors];
};

// Lösche ausstehende Fehler (nach erfolgreichem Upload)
export const clearPendingErrors = () => {
  pendingErrors = [];
};

// Exportiere Funktionen für App.jsx
export { sendErrorToBackend, saveErrorToIndexedDB };
